import { render, staticRenderFns } from "./MenuCard.vue?vue&type=template&id=179f754c&scoped=true"
import script from "./MenuCard.vue?vue&type=script&lang=js"
export * from "./MenuCard.vue?vue&type=script&lang=js"
import style0 from "./MenuCard.vue?vue&type=style&index=0&id=179f754c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179f754c",
  null
  
)

export default component.exports